<!--
 * @Author: wh
 * @Date: 2020-07-10 11:13:52
 * @LastEditTime: 2021-10-26 15:39:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_test\src\views\salesTerminal\overApplication\overContractInfo.vue
-->
<template>
    <div class="overContractInfo">
        <van-nav-bar
            title="超限发货"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <section class="van-pull-refresh">
            <van-cell-group>
                <van-cell
                    title="合同编号"
                    :value="formData.contract_number"
                    :icon="require('@/assets/images/icons/icon_gy_1.png')"
                ></van-cell>
                <van-cell
                    title="合同类型"
                    :value="formData.contract_type_name"
                    :icon="require('@/assets/images/icons/icon_gy_3.png')"
                ></van-cell>
                <van-cell
                    title="工程名称"
                    :value="formData.engineering_name"
                    :icon="require('@/assets/images/icons/icon_2.png')"
                ></van-cell>
                <van-cell
                    title="应收账款余额(万元)"
                    :value="accounts_receivable_balance"
                    :icon="require('@/assets/images/icons/icon_2.png')"
                ></van-cell>
                <van-cell
                    title="工程地址"
                    :value="formData.engineering_location"
                    :icon="require('@/assets/images/icons/icon_gy_2.png')"
                ></van-cell>
                <van-cell
                    title="客户名称"
                    :value="formData.client_name"
                    :icon="require('@/assets/images/icons/icon_3.png')"
                ></van-cell>
                <van-cell
                    title="统一社会信用代码"
                    :value="formData.client_uscc"
                    :icon="require('@/assets/images/icons/icon_33.png')"
                ></van-cell>
                <van-cell
                    title="限制类型"
                    :value="formData.limit_type_name"
                    :icon="require('@/assets/images/icons/icon_gy_5.png')"
                ></van-cell>
                <van-cell
                    title="申请说明"
                    :value="formData.application_reason"
                    :icon="require('@/assets/images/icons/icon_34.png')"
                ></van-cell>
                <van-cell
                    title="申请人"
                    :value="formData.application_name"
                    :icon="require('@/assets/images/icons/icon_3.png')"
                ></van-cell>
                <van-cell
                    title="申请时间"
                    :value="formData.application_time"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                ></van-cell>
                <van-cell
                    title="超限发货量"
                    :value="formData.client_name"
                    :icon="require('@/assets/images/icons/icon_6.png')"
                ></van-cell>
                <van-field
                    class="trans-types"
                >
                    <template #input>
                        <div>
                            <van-checkbox-group
                                v-model="formData.overrun_despatch_mode"
                                readonly
                                direction="horizontal"
                            >
                                <van-checkbox
                                    name="1"
                                    icon-size="15px"
                                    readonly
                                    disabled
                                    shape="square"
                                >
                                    按金额
                                </van-checkbox>
                                <van-checkbox
                                    name="2"
                                    icon-size="15px"
                                    readonly
                                    disabled
                                    shape="square"
                                >
                                    按方量
                                </van-checkbox>
                                <van-checkbox
                                    name="3"
                                    icon-size="15px"
                                    readonly
                                    disabled
                                    shape="square"
                                >
                                    按时间
                                </van-checkbox>
                            </van-checkbox-group>
                        </div>
                        <!-- v-show="!creditDisable" -->
                        <div
                            class="credit-limit"
                            v-show="!creditDisable"
                        >
                            <span>占用个人信用额度：</span>
                            <van-radio-group
                                v-model="formData.is_saleman"
                                direction="horizontal"
                                disabled
                            >
                                <van-radio :name="true" icon-size="15px">
                                    是
                                </van-radio>
                                <van-radio :name="false" icon-size="15px">
                                    否
                                </van-radio>
                            </van-radio-group>
                        </div>
                        <div>
                            <div class="custom-row">
                                <span>允许再供应</span>
                                <input
                                    :value="formData.overrun_despatch_money"
                                    readonly
                                    type="number"
                                >
                                <span>万元混凝土</span>
                            </div>
                            <div class="custom-row">
                                <span>允许再供应</span>
                                <input
                                    :value="formData.overrun_despatch_amount"
                                    readonly
                                    type="number"
                                >
                                <span>方混凝土</span>
                            </div>
                            <div class="custom-row">
                                <span>允许再供应至</span>
                                <input
                                    v-model="formData.overrun_despatch_time"
                                    readonly
                                >
                                <span>日</span>
                            </div>
                        </div>
                        <div class="tooltip">
                            <span class="red">提示：</span>
                            <!-- <p>
                                {{ formData.limit_reason }}
                            </p> -->
                            <p>{{ formData.other_reason }}</p>
                            <p>{{ formData.transfinite_shipments_record }}</p>
                        </div>
                    </template>
                </van-field>
                <van-field
                    :left-icon="require('@/assets/images/icons/icon_24.png')"
                    label="附件"
                    placeholder=""
                    input-align="right"
                    readonly
                    clickable
                    is-link
                    @click="toUpload"
                >
                </van-field>
                <div class="approvalComments">
                    <h3 class="iconfont iconpingjia">
                        审批意见
                    </h3>
                    <ul v-if="formData.approvalOpinionList">
                        <template v-for="(item, index) in formData.approvalOpinionList">
                            <li :key="`opinion_${index}`">
                                <div class="headPortrait iconfont icon04gerenfill"></div>
                                <div class="userInfo">
                                    <div class="userName">
                                        <h4>{{ item.signer_name }}</h4>
                                        <span>{{ item.created }}</span>
                                    </div>
                                    <p class="role">
                                        {{ item.signer_role_name }}
                                    </p>
                                    <p class="opinion">
                                        {{ item.opinion }}
                                    </p>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
            </van-cell-group>
        </section>
        <!-- 加载层 -->
        <van-overlay :show="showOverlay">
            <van-loading type="spinner"></van-loading>
        </van-overlay>
    </div>
</template>

<script>
export default {
    name: 'over-contract-info',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (['/approvalProcess', '/overApplication'].indexOf(to.path) > -1) {
            this.$store.commit('noKeepAlive', 'over-contract-info');
        }
        next();
    },
    data() {
        return {
            // 表单数据
            formData: {},
            accounts_receivable_balance: '',
            // 超限申请id
            ctsid: '',
            // 加载层
            showOverlay: false,
            creditDisable: true,
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ name: 'overApplication' });
            this.$router.go(-1);
        },
        // 上传附件
        toUpload() {
            let BusinessInstanceId = '';
            BusinessInstanceId = this.formData.business_instance_id;
            this.$router.isBack = 2;
            this.$router.push({
                name: 'fileUpload',
                params: {
                    formData: this.formData,
                    BusinessInstanceId: BusinessInstanceId,
                    type: this.type,
                    // isView: true,
                    fromPath: 'overContractInfo',
                    title: '附件资料',
                },
            });
        },
        // 获取超发申请详情
        getRetailDetail() {
            this.showOverlay = true;
            this.$axios
                .get('/interfaceApi/sale/contract_transfinite/get_retail_detail/' + this.ctsid)
                .then(res => {
                    if (res) {
                        res.overrun_despatch_money = res.overrun_despatch_money + '';
                        res.overrun_despatch_amount = res.overrun_despatch_amount + '';

                        if (res.overrun_despatch_mode) {
                            if (res.overrun_despatch_mode.indexOf(1) > -1) {
                                this.creditDisable = false;
                            }
                            if (res.overrun_despatch_mode.indexOf(',') === -1) {
                                res.overrun_despatch_mode = [res.overrun_despatch_mode];
                            } else {
                                res.overrun_despatch_mode = res.overrun_despatch_mode.split(',');
                            }
                        } else {
                            res.overrun_despatch_mode = [];
                        }
                        this.formData = res;
                        this.showOverlay = false;
                        this.handleImplement(res.contract_version_id);
                    }
                }).catch(error => {
                    this.showOverlay = false;
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 拉取合同执行信息
        handleImplement(id) {
            // this.formData.overdue_arrears = 1;
            this.$axios
                .get('/interfaceApi/sale/contract_manager/get_implement_cvid/' + id)
                .then(res => {
                    this.accounts_receivable_balance = (res.accounts_receivable_balance / 10000).toFixed(2);
                    this.$forceUpdate();
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 拉取合同执行信息
        getImplement(id) {
            const path = '/interfaceApi/sale/contract_manager/get_implement_cvid/' + id;
            return this.$axios.$get(path, { defEx: true });
        },
    },
    created() {
        this.ctsid = this.$route.params.ctsid;
        this.getRetailDetail();
    },
    mounted() {},
};
</script>
<style lang="stylus">
.overContractInfo
    .van-pull-refresh
        height calc(100% - 45rpx)
        overflow-y auto
        padding-bottom 40rpx
        .trans-types
            padding-left 30rpx
            .van-field__control--custom
                display block
                .van-radio-group
                    margin-bottom 10rpx
            .custom-row
                margin-bottom 10rpx
                input
                    width 100rpx
                    border 0
                    border-bottom 1px solid #ccc
                    margin 0 10rpx
                    border-radius 0
            .credit-limit
                margin 10rpx 0
                display flex
                span
                    margin-right 15rpx
            .tooltip
                font-size 12rpx
                .red
                    color #E50000
                p
                    text-indent 1rem
        .approvalComments
            padding 10rpx 15rpx
            border-top 15rpx solid #F0F0F0
            h3
                font-size 18rpx
                line-height 28rpx
                color #3495FB
            ul
                li
                    padding-top 10rpx
                    border-bottom 1px dashed #D7D7D7
                    display flex
                    &:last-child
                        border-bottom none
                    .headPortrait
                        width 36rpx
                        height 36rpx
                        border 1px solid #ADCDE4
                        background #ADCDE4
                        font-size 20rpx
                        line-height 36rpx
                        text-align center
                        border-radius 50%
                        color #fff
                        margin-right 10rpx
                    .userInfo
                        width calc(100% - 46rpx)
                        .userName
                            display flex
                            justify-content space-between
                            line-height 24rpx
                            h4
                                font-size 16rpx
                                color #333333
                            span
                                font-size 12rpx
                                color #979EA7
                        .role
                            font-size 12rpx
                            color #979EA7
                            margin-bottom 5rpx
                        .opinion
                            font-size 14rpx
                            line-height 22rpx
                            color #666666
    .van-overlay
        .van-loading
            position absolute
            z-index 100
            top 50%
            left 50%
</style>
